import React from 'react';
import { TextField } from '@mui/material';
import EthiopianTimeField from './EthiopianTimeField';
export default function CalendarTimeField({ value, onChange, clock, label, disabled, error }) {
  return ['ethiopian', 'both'].includes(clock) ? <EthiopianTimeField {...{ value, onChange, label, disabled, error }} showStandard={clock === 'both'} /> : <TextField type="time" size="small" label={label} value={value || ''} onChange={e => onChange(e.target.value)} disabled={disabled} error={error} InputLabelProps={{ shrink: true }} />;
}
